// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const uploadsClient = createTypedClient();
export const createUploadsClient = (config) => createTypedClient(config);
